<template>
  <div class="header-search">
    <div class="header-search__input-container">
      <div class="header-search__input-wrapp">
        <BaseSearch
          auto-focus
          theme="header"
          @search="handleSearch"
        />
      </div>
      <BaseButton
        class="header-search__close-btn"
        type="button"
        aria-label="Закрыть поиск"
        @click="handleCloseSearch"
      >
        Закрыть
      </BaseButton>
    </div>
  </div>
</template>

<script lang="ts">
  import BaseButton from '~/components/BaseComponents/BaseButton.vue';
  import BaseSearch from '~/components/BaseComponents/BaseSearch.vue';

  export default defineNuxtComponent({
    name: 'HeaderSearch',

    components: { BaseButton, BaseSearch },

    emits: ['search', 'close-search'],

    methods: {
      handleSearch(): void {
        this.$emit('search');
      },

      handleCloseSearch($event: MouseEvent): void {
        this.$emit('close-search', $event);
      },
    },
  });
</script>

<style lang="scss" scoped>
  @use '../styles/TheHeader.variables' as *;

  .header-search {
    @include normalText;

    &__input-container {
      padding: $spacing-0 $spacing-4 0;
      @include desktop {
        padding: $spacing-0 $spacing-10;
      }

      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__input-wrapp {
      width: 100%;
      margin-right: $spacing-4;
    }

    &__close-btn {
      color: $headerSearchFontColor;
      font-weight: 500;
      font-size: 14px;
      height: 48px;
      width: 84px;
      @include hover {
        background-color: $headerHoverItemColor;
      }
    }
  }
</style>
